module.exports = __webpack_public_path__ + "img/kmoffline.dark.886c6f14.svg";